<template>
    <div>
        <h-table
                :data='data'
                row-key="label"
                :columns='columns'
                :loading="loading"
                ref="table"
        >
            <q-tr slot="header" slot-scope="props" ref="thead">
                <h-th v-for="(col, index) in props.cols" :key="col.name" :props="props" :class="{'loading': loading}">
                    <q-icon v-if="col.hasOwnProperty('filter')" name="filter_list" class="q-table-filter-icon">
                        <q-popover anchor="bottom left" self="top left" @show="$refs.search[index].focus()">
                            <div class="q-pa-sm">
                                <q-input v-model="col.filter" @keyup.enter="search(col)" :before="[{icon: 'search'}]"
                                         ref="search"/>
                            </div>
                        </q-popover>
                    </q-icon>
                    {{col.label}}
                </h-th>
            </q-tr>
            <q-td slot="body-cell-edit" slot-scope="props" class="text-right">
                <q-btn @click="revokeToken(props.row.id)" icon="delete" color="tertiary" class="hover-primary" flat round />
            </q-td>
        </h-table>
        <q-modal v-model="personalTokenResultOpened" content-css="width: 600px;">
            <div class="q-pa-lg">
                <p>Убедитесь что Вы сохранили API токен в надёжное место, т. к. после закрытия окна он будет более не доступен для копирования</p>
                <q-field>
                    <q-input v-model="token.accessToken"
                             stack-label="Token"
                             type="textarea"
                             :max-height="100"
                             rows="7"
                             :readonly="true"
                             ref="accessToken"
                             @click="$refs.accessToken.select()"
                             class="accessToken-textarea"
                    />
                </q-field>
            </div>
            <div class="row justify-end q-pa-lg">
                <q-btn label="Закрыть" style="margin-right: 10px;" @click="personalTokenResultOpened=false"/>
            </div>
        </q-modal>
        <q-modal v-model="personalTokenFormOpened" content-css="width: 400px;">
            <div class="q-pa-lg">
                <q-field>
                    <q-input v-model="token.name" stack-label="Название"/>
                </q-field>
            </div>
            <div class="row justify-end q-pa-lg">
                <q-btn label="Отмена" style="margin-right: 10px;" @click="personalTokenFormOpened=false"/>
                <q-btn label="Сохранить" color="primary" @click="saveToken"/>
            </div>
        </q-modal>
        <div>
            <q-btn label="Создать API токен" icon="add" color="positive" @click="personalTokenFormOpened=true"/>
        </div>
    </div>
</template>

<script>
  import HTable from '@/HTable';
  import HTh from '@/HTh';


  import tableHelpers from 'components/HTable/helpers';

  import {
    QField,
    QInput,
    QSelect,
    QBtn,
    QIcon,
    QTable,
    QTableColumns,
    QTr,
    QTh,
    QTd,
    QPopover,
    QModal,
    QDialog
  } from 'quasar';

  export default {
    name: "Tokens",
    components: {
      HTable,
      HTh,
      QField,
      QInput,
      QSelect,
      QBtn,
      QIcon,
      QTable,
      QTableColumns,
      QTr,
      QTh,
      QTd,
      QPopover,
      QModal,
      QDialog
    },
    mixins: [
      tableHelpers
    ],
    props: {
      userId: String
    },
    data() {
      return {
        columns: [
          {
            label: 'Название',
            field: 'name',
            name: 'name',
            sortable: false,
            align: 'left'
          },
          {
            label: 'Дата создания',
            field: 'created_at',
            name: 'created_at',
            sortable: false,
            align: 'left'
          },
          {
            label: 'Действителен до',
            field: 'expires_at',
            name: 'expires_at',
            sortable: false,
            align: 'left'
          },
          {
            label: 'Действия',
            name: 'edit',
            field: 'id',
            sortable: false,
            align: 'right'
          }
        ],
        //visibleColumns: ['first_name', 'last_name', 'email', 'role', 'edit'],
        data: [],
        loading: false,
        perPageOptions: [10, 20, 40, 60],
        filterCols: {},
        personalTokenFormOpened: false,
        personalTokenResultOpened: false,
        token: {
          name: '',
          accessToken: ''
        },
        serverPagination: {
          descending: false,
          page: 1,
          rowsNumber: 0, // specifying this determines pagination is server-side
          rowsPerPage: 10,
          sortBy: {'created_at': "DESC"}
        },
      };
    },
    mounted() {
      this.fetchTokens();
    },
    methods: {
      fetchTokens() {
        this.loading = true;
        this.$http.get(`api/v1.0/users/${this.$route.params.id}/tokens`).then((response) => {
          this.data = response.data;
          this.serverPagination.rowsNumber = response.data.length;

          this.loading = false
        }).catch(error => {
          console.error(error);

          // we tell QTable to exit the "loading" state
          this.loading = false
        });
      },
      saveToken() {
        this.$http.post(`/api/v1.0/users/${this.$route.params.id}/tokens`, this.token)
          .then(response => {
            this.token.name = '';
            this.personalTokenFormOpened = false;
            this.personalTokenResultOpened = true;
            this.fetchTokens();
            this.$q.notify({message: 'Сохранено', type: 'positive'});

            this.token.accessToken = response.data.accessToken;
          })
          .catch(error => {
            console.error(error.response.data.message);
            this.$q.notify({message: 'Ошибка', type: 'negative'});
          })
      },
      revokeToken(id) {
        this.$q.dialog({
          title: 'Внимание!',
          message: 'Вы действительно хотите отозвать API токен?',

          // optional
          color: 'primary',

          // optional; we want an "OK" button
          ok: true, // takes i18n value, or String for "OK" button label

          // optional; we want a "Cancel" button
          cancel: true, // takes i18n value, or String for "Cancel" button label

          // optional; a position of the Dialog (top, bottom, left, right)
          //position: 'top',
        }).then(() => {
          this.$http.delete(`/api/v1.0/users/${this.$route.params.id}/tokens/${id}`, this.token)
            .then(response => {
              this.fetchTokens();
              this.$q.notify({message: 'Удалено', type: 'positive'});
            })
            .catch(error => {
              console.error(error.response.data.message);
              this.$q.notify({message: 'Ошибка', type: 'negative'});
            })
        });
      }
    }
  }
</script>

<style scoped>
    .accessToken-textarea {
        font-family: "Courier New", Courier, monospace;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/TokensList/TokensList.vue